import type { SVGAttributes } from "react";
import type { DefaultTheme } from "styled-components";
import type { SpaceProps } from "styled-system";

// Sizes
export enum svgSize {
  STANDARD = "24px",
  SMALLER = "16px",
}

export const svgSizes = Object.freeze({ ...svgSize });
export type SvgSizes = (typeof svgSizes)[keyof typeof svgSizes];

export interface SvgProps extends SVGAttributes<HTMLOrSVGElement>, SpaceProps {
  width?: number;
  height?: number;
  size?: SvgSizes;
  color?: string;
  colorSecondary?: string;
  theme?: DefaultTheme;
  spin?: boolean;
  fill?: string;
  stoke?: string;
  stroke?: string;
  opac?: boolean;
}
